module.exports = __webpack_public_path__ + "img/default-header.d7947063.png";